import { createRoot } from "react-dom/client"
import { I18nextProvider } from "react-i18next"
import { Provider } from "react-redux"
import { store } from "../../../app"
import RootLayout from "../../../shared/Layouts/RootLayout"
import "../../../styles/main.css"
import App from "./App"

const mount = async () => {
  const container = document.getElementById("saved-tours-settings")
  if (!container) return

  const props = JSON.parse(container.getAttribute("data-props") || "{}")

  const i18n = window.i18n
  if (!i18n) {
    window.addEventListener("i18n:ready", mount, { once: true })
    return
  }

  if (props.locale) {
    await i18n.changeLanguage(props.locale)
  }

  const root = createRoot(container)
  root.render(
    <Provider store={store}>
      <I18nextProvider i18n={i18n}>
        <RootLayout themeName={props?.themeName ?? "default"}>
          <App {...props} />
        </RootLayout>
      </I18nextProvider>
    </Provider>
  )
}

document.addEventListener("DOMContentLoaded", mount)
